import { ConnectionModel, MyConnection, SearchConnection } from '@/types'
import { createContext, Context } from 'react'
import { ListingGenericContext } from './ListingGenericContext'

type ConnectionsListUser = ConnectionModel | MyConnection | SearchConnection

interface ConnectionsListContextProps extends ListingGenericContext<ConnectionsListUser> {}

export const ConnectionsListContext: Context<ConnectionsListContextProps> = createContext(
  {} as ConnectionsListContextProps,
)
